import React from 'react';
const ChevronRightIcon = () => /*#__PURE__*/React.createElement("span", {
  className: "material-icons md-18 ms-1",
  style: {
    verticalAlign: 'middle'
  }
}, "chevron_right");
export default ChevronRightIcon;